<template lang="pug">
  v-container#location(fluid)
    h1.form-title.dark-text Ubicación en el mapa
    h2.form-subtitle Busca la dirección y arrastra el pin.
    v-layout(row wrap d-flex justify-space-between)
      v-form.d-flex.xs12.justify-space-between
        v-flex(xs5)
          v-text-field(
            v-model="place"
            label="Nombre del punto"
            data-vv-name="name"
            :value="locationName"
          )
        //v-flex(xs5)
          v-text-field(
            v-model="address"
            label="Dirección en el mapa"
            data-vv-name="address"
            required
          )
        //v-flex(xs5)
          v-text-field(
            v-model="lat"
            label="Latitud"
            data-vv-name="lat"
            required
          )
        //v-flex(xs5)
          v-text-field(
            v-model="lng"
            label="Longitud"
            data-vv-name="lng"
            required
          )
          types="establishment address"
        v-flex(xs5)
          .input-group.input-group--text-field.primary--text
            vue-google-autocomplete(
              ref="address"
              id="map"
              classname="form-control"
              :placeholder="direccion"
              v-on:placechanged="getAddressData"
              types="geocode"
              country="mx"
            )
          .input-group__details.location
          //v-model="report.features.locationName"
    v-layout(row wrap)
      v-flex(d-flex)
        #mymap
</template>
<script>
import * as L from "leaflet";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "Location",
  components: { VueGoogleAutocomplete },
  props: {},
  data() {
    return {
      locationName: "",
      locationAddress: "",
      mymap: undefined,
      markerAlready: false,
      Marker: undefined
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    place: {
      get() {
        return this.$store.state.record.place;
      },
      set(value) {
        this.$store.commit("updatePlace", value);
      }
    },
    direccion() {
      return this.$store.state.record.address || 'Dirección';
    },
    address: {
      get() {
        return this.$store.state.record.address;
      },
      set(value) {
        this.$store.commit("updateAddress", value);
      }
    },
    lat: {
      get() {
        return this.$store.state.record.lat;
      },
      set(value) {
        this.$store.commit("updateLat", value);
      }
    },
    lng: {
      get() {
        return this.$store.state.record.lng;
      },
      set(value) {
        this.$store.commit("updateLng", value);
      }
    }
  },
  methods: {
    getAddressData: function(addressData, placeResultData, id) {
      this.record.lat = addressData.latitude.toString();
      this.record.lng = addressData.longitude.toString();
      this.record.address = placeResultData.formatted_address;

      this.locationName = placeResultData.formatted_address;
      this.locationAddress = {
        lat: addressData.latitude,
        long: addressData.longitude
      };
      this.mymap.setView(
        [this.locationAddress.lat, this.locationAddress.long],
        17
      );
      if (!this.markerAlready) {
        this.Marker = L.marker(
          [this.locationAddress.lat, this.locationAddress.long],
          {
            draggable: true
          }
        );
        if (this.Marker) {
          this.Marker.on("move", e => {
            this.locationAddress = e.latlng;
          });
          this.Marker.on("dragend", e => {
            this.geocode(this.locationAddress);
          });
        }

        this.Marker.addTo(this.mymap);
      } else {
        this.Marker.setLatLng([
          this.locationAddress.lat,
          this.locationAddress.long
        ]);
      }
      this.markerAlready = true;
    },
    drawMap: function() {
      delete L.Icon.Default.prototype._getIconUrl;

      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
      });

      let iconUrl = "https://www.iconsdb.com/icons/preview/red/circle-xxl.png";
      let icon = L.icon({
        iconRetinaUrl: iconUrl,
        iconUrl: iconUrl,
        iconSize: 10
      });

      this.mymap = L.map("mymap").setView([23.6345, -102.5528], 5);
      this.mymap.scrollWheelZoom.disable();
      // let tileLayer =
      //   "https://api.tiles.mapbox.com/v4/mapbox.dark/{z}/{x}/{y}@2x.png";
      // let accessToken =
      //   "pk.eyJ1Ijoiam9yYW5kcmFkZWZpZyIsImEiOiJjamV0bm9vczAzMTc3MnlvMG4wMTBlaXY0In0.6Te0HBRHyNH0TAVIQNT89w";
      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/light-v10",
          accessToken:
            "pk.eyJ1Ijoiam9yYW5kcmFkZWZpZyIsImEiOiJjamV0bm9vczAzMTc3MnlvMG4wMTBlaXY0In0.6Te0HBRHyNH0TAVIQNT89w"
        }
      ).addTo(this.mymap);
    },
    drawLocationMarker() {
      let lat = this.record.lat.toString();
      let lng = this.record.lng.toString();

        this.Marker = L.marker(
          [lat, lng],
          {
            draggable: true
          }
        );
        this.Marker.addTo(this.mymap);
        this.markerAlready = true;
    },
    geocode: function(latlng) {
      var that = this;
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, function(results, status) {
        if (status === "OK") {
          if (results[0]) {
            this.locationAddress = latlng;
            this.locationName = results[0].formatted_address;

            that.$refs.address.$el.value = locationName;
            that.record.address = locationName;
            that.record.lat = latlng.lat.toString();
            that.record.lng = latlng.lng.toString();
          } else {
            window.alert("No se encontraron resultados");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    }
  },
  mounted() {
    this.drawMap();
    this.drawLocationMarker();
  }
};
</script>
<style scoped lang="scss">
@import "../global.scss";

.form-subtitle {
  color: $light-text !important;
  font-size: 14px !important;
}

.input-group__details.location {
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-top: 4px;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 100%;
  flex: 1 0 100%;
  font-size: 12px;
  min-height: 26px;
  overflow: hidden;
  position: relative;
  width: 100%;
  &:before {
    background-color: rgba(0, 0, 0, 0.42);
    top: 0;
    height: 1px;
    width: 100%;
    z-index: 0;
  }
  &:after {
    background-color: rgb(43, 72, 148);
    color: inherit;
    top: 0;
    height: 2px;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: center center 0;
    transform-origin: center center 0;
    width: 100%;
    z-index: 1;
  }
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    -webkit-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

#mymap {
  width: 100%;
  height: 500px;
}
</style>
